import { gql } from '@apollo/client';

export const AUTH = gql`
  mutation authenticate($login: String!, $password: String!) {
    authenticate(input: { login: $login, password: $password })
  }
`;
